<mat-card>

  <mat-card-header>
    <mat-card-title>Empadronamiento de Persona</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <div mat-dialog-content style="margin: 15px 0px; text-align: center;">

      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="!isValidating && msgError.length > 0">{{msgError}}</mat-label>

    </div>

    <ng-container *ngIf="isValid">

      <div mat-dialog-content *ngIf="existingUser" style="margin: 15px 0px; text-align: center;">
        <mat-label>Detectamos que ya tenes un usuario asociado a este correo, por lo tanto te pedimos que inicies sesión con tu usuario y clave para ver las novedades</mat-label> 
      </div>

      <div mat-dialog-content *ngIf="!existingUser">

        <form [formGroup]="formUserGroup">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
              <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Por favor completa tus datos personales</mat-label>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="Nombre" type="text" (keyup.enter)="onGuardar()" maxlength="150">
                <mat-error *ngIf="!formUserGroup.controls['Nombre'].valid && formUserGroup.controls['Nombre'].touched">
                  {{ getErrorNombre() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Apellido</mat-label>
                <input matInput formControlName="Apellido" type="text" (keyup.enter)="onGuardar()" maxlength="150">
                <mat-error *ngIf="!formUserGroup.controls['Apellido'].valid && formUserGroup.controls['Apellido'].touched">
                  {{ getErrorApellido() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Documento</mat-label>
                <input matInput formControlName="NroDocumento" type="text" (keyup.enter)="onGuardar()" maxlength="100">
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Móvil</mat-label>
                <input matInput formControlName="Movil" type="text" (keyup.enter)="onGuardar()" maxlength="100">
              </mat-form-field>
            </div>
          </div>

          <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center">
              <mat-label style="text-align: center; font-weight: bold; margin-bottom: 10px;">Ahora por favor completa los datos del usuario que queres crear</mat-label>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 15px;">
                  <mat-label><b>Mail</b>: {{formUserGroup.controls['Mail']?.value}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre de Usuario*</mat-label>
                <input matInput formControlName="Login" type="text" (keyup.enter)="onGuardar()" maxlength="100">
                <mat-error *ngIf="!formUserGroup.controls['Login'].valid && formUserGroup.controls['Login'].touched">
                  {{ getErrorLogin() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Clave*</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="Clave" (keyup.enter)="onGuardar()">
                <mat-error *ngIf="!formUserGroup.controls['Clave'].valid && formUserGroup.controls['Clave'].touched">
                  {{ getErrorClave() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Confirma tu Clave*</mat-label>
                <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="ConfirmClave" (keyup.enter)="onGuardar()">
                <mat-error *ngIf="!formUserGroup.controls['ConfirmClave'].valid && formUserGroup.controls['ConfirmClave'].touched">
                  {{ getErrorConfirmClave() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

        </form>

      </div>

    </ng-container>

    <div mat-dialog-actions align="center">
      <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
        <button mat-raised-button color="primary" (click)="onGuardar()" [disabled]="!buttonEnabled" *ngIf="isValid && !existingUser" class="zb-button">
          <mat-icon style="margin-right: 5px;">input</mat-icon> {{buttonEnabled ? 'Crear' : 'Creando...'}}
        </button>
        <button mat-raised-button color="warn" (click)="onCancelar()" [disabled]="!buttonEnabled" class="zb-button">
          <mat-icon style="margin-right: 5px;">cancel</mat-icon>{{isValid ? 'Cancelar' : 'Ir a Inicio'}}
        </button>
      </div>
    </div>

  </mat-card-content>

</mat-card>